import Login from './Views/Auth/auth.reducer'
import Forms from './Views/Forms/forms.reducer'
import Company from './Controllers/Company/company.reducer'
import Points from './Controllers/Points/points.reducer'
import Clasifications from './Controllers/Clasifications/clasifications.reducer'
import Tags from './Controllers/Tags/tags.reducers'
import Extras from './Controllers/Extras/extras.reducers'
import Addons from './Controllers/Addons/addons.reducer'
import Widgets from './Controllers/Widgets/widgets.reducer'

export default {
  Login,
  Forms,
  Points,
  Company,
  Clasifications,
  Tags,
  Extras,
  Addons,
  Widgets,
}
